import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import AddModel from "../../../components/Add/AddModel";
import AddBottomButton from "../../../components/Add/AddBottomButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { useEffect, useRef, useState } from "react";
import {
  setInstructionText,
  setIsOpenModel,
} from "../../../store/slices/modelSlice";
import useApi from "../../../services/useApi";
import { showToast } from "../../../components/toastMessage/toastSlice";
import endpoints from "../../../services/endpoints";
import { formEmptyValidation } from "../../../components/commonfunctions/formEmptyValidation";
import { setErrorMessage, setOtp, resetOtp } from "../../auth/otpSlice";
import { setLoading } from "../../auth/loginSlice";
import { transformString } from "../../../components/commonfunctions/transformString";
import { ProgressStepper } from "../../../components/Add/ProgressBar/ProgressStepper";
import { resetPhoneNumbers, setErrorById, setIsVerifiedById, setLoadingStateById, setPhoneNumber, setVerifiedSecondaryPhoneNumbers } from '../../../store/slices/phoneNumbersSlice'
import {
  resetAddMD,
  resetBankDetails,
  resetIdentificationDetails,
  resetPhotoUploads,
  setAddLoading,
  setAddMDError,
  setAddMDFelidError,
  setAddMDLoader,
  setCheckBox,
  setCompleteServiceFee,
  setDisableState,
  setEditSavedData,
  setHasChildren,
  setIsVerifiedFirst,
  setPayloadFornationality,
  setProfileStatus,
  setSavedData,
  setSecondaryPhoneNumbers,
  setUpdateMDStates,
  setUserId,
  setVerifiedEmailAddress,
  setVerifiedPhoneNumber,
  setVerifiedRecoveryEmailAddress,
  updateMDDetails,
  setIsApiUser,
  setWhitelistedIps,
} from "./addMDSlice";
import BasicDetails from "./Components/BasicDetails";
import IdentificationDetails, { ChildRef } from "./Components/IdentificationDetails";
import { convertDate } from "../../../components/commonfunctions/convertDate";
import { resetBusinessAreas, setProvinces, setRegion } from "../../../store/slices/businessAreasSlice";
import { resetLocation, setCoordinates, setLocationInfo, setShowFields } from "../../../store/slices/geolocationSlice";
import { getFirefoxCssFix } from "../../../components/commonfunctions/getFirefoxCssFix";
import BankDetails, { bankDetailsRef } from "./Components/BankDetails";
import BusinessDetails, { businessDetailsRef } from "./Components/BusinessDetails";
import PhotoUploadWithValidation from "./Components/PhotoUpload";
import deepEqual from "../../../components/commonfunctions/deepEqual";
import config from "../../../config/config";
import ServiceFee, { serviceFeeRef } from "./Components/ServiceFee";
import AddCVM from "./Components/AddCVM";
import CustomRadioButton from "../../../components/buttons/CustomRadioButton";
import CorporateDetails, { corporateDetailsRef } from "./Components/CorporateDetails";
import { setCorporateDetails } from "../../../store/slices/corporateDetailsSlice";

export default function AddMD({ type, testCurrentStep, firstIndex, testingId, tab, customerType, step, edit }: { type: string, testCurrentStep?: number, firstIndex?: boolean, testingId?: string, tab?: string, customerType?: string, step?: number, edit?: boolean }) {
  const dispatch = useDispatch<AppDispatch>();
  const {
    addAdminDetails,
    felidError,
    errors,
    add_loading,
    addMDLoader,
    wallet_access,
    wallet_access_edit,
    is_api_user,
    is_api_user_edit,
    whitelisted_ips,
    whitelisted_ips_edit,
    editData,
    disableAll,
    isVerifiedFirst,
    savedData,
    identificationDetails,
    bankDetails,
    photoUpload,
    user_id,
    verifiedPhoneNumber,
    verifiedEmailAddress,
    verifiedRecoveryEmailAddress,
    secondary_phone_numbers
  } = useSelector((state: RootState) => state.addMD);
  const businessAreas = useSelector((state: RootState) => state.businessAreas)
  const { otp } = useSelector((state: any) => state.otp);
  const corporateDetails = useSelector((state: any) => state.expandedCorporateDetails);
  const childRef = useRef<ChildRef>(null);
  const photoUploadRef = useRef<ChildRef>(null);
  const bankDetailsRef = useRef<bankDetailsRef>(null);
  const businessDetailsRef = useRef<businessDetailsRef>(null);
  const serviceFeeRef = useRef<serviceFeeRef>(null);
  const corporateCustomerRef = useRef<corporateDetailsRef>(null);
  const [isOpenOtpModel, setIsOpenOtpModel] = useState(false);
  const [apiAccessError, setApiAccessError] = useState('');
  const [ipErrors, setIpErrors] = useState<string[]>([]);
  const { selectedOTPid } = useSelector((state: any) => state.model);
  const [currentStep, setCurrentStep] = useState(testCurrentStep ? testCurrentStep : 1);
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const userPreviousUrl = useSelector((state: RootState) => state.geolocation.userManagementUrl);
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const [isUploadedPhoto, setIsUploadedPhoto] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>(customerType ? customerType : 'Individual');
  const navigate = useNavigate();
  const { id } = useParams();
  const { otpVerify, otpSend } = endpoints;
  const userType = type;
  const {
    first_name,
    email_address,
    phone_number,
    country,
    province,
    district,
    postal_code,
    city_town,
    house_no,
    market_block_no,
    floor_no,
    street_name,
    region,
    gender,
    date_of_birth,
    nationality,
    profession,
    last_name,
    email_address_verify,
    phone_number_verify,
    country_code,
    recovery_email_address,
  } = addAdminDetails;
  const { PostAPI, PatchAPI, getAPI } = useApi();
  const { phoneNumbers } = useSelector((state: RootState) => state.phoneNumbers)
  const { coordinates, locationInfo } = useSelector((state: RootState) => state.geolocation);
  const { areas } = useSelector((state: RootState) => state.businessAreas)
  const divRef = useRef(null);
  const location = useLocation()
  const [editLoading, setEditLoading] = useState(false);
  const [disableServiceFee, setDisableServiceFee] = useState(false)
  const [addCvmClicked, setAddCvmClicked] = useState(false)
  const [hasServiceFeeChanges, setHasServiceFeeChanges] = useState(false)
  const [isServiceFeeEditModalOpen, setIsServiceFeeEditModalOpen] = useState(false)
  const [inputCordinates, setInputCordinates] = useState<{ latitude: number | null; longitude: number | null; }>({
    latitude: null,
    longitude: null,
  })

  let userId = id || testingId;
  const [currentPhone, setCurrentPhone] = useState('')
  const [emailEdited, setEmailEdited] = useState(false)
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const { profile } = useSelector((state: RootState) => state.addMD);

  const handleInputValues = (key: string, value: string) => {
    // Check if the input field is 'first_name' or 'last_name'
    if (key === 'first_name' || key === 'last_name' || key === 'mothers_name') {
      // Regular expression to allow only alphabets and spaces
      const regex = /^[A-Za-z\s]*$/;
      // If the value contains numbers or special characters, stop execution and return
      if (!regex.test(value)) {
        return;
      }
    }

    // Dispatch an action to update the state with the new key-value pair
    dispatch(setUpdateMDStates({ key, value }));

    // Switch case to handle specific keys
    switch (key) {
      case "phone_number":
        // Update the phone_number_verify state based on conditions
        if ('+' + value === verifiedPhoneNumber) {
          dispatch(setUpdateMDStates({
            key: "phone_number_verify",
            value: 'true'
          }))
        } else {
          dispatch(
            setUpdateMDStates({
              key: "phone_number_verify",
              value: userId
                ? editData.phone_number === value && isVerifiedFirst
                  ? "true"
                  : ""
                : "",
            })
          );
        }
        break;

      case "email_address":
        // Reset email verification status when email address changes
        if (verifiedEmailAddress !== '' && verifiedEmailAddress === value) {
          dispatch(setUpdateMDStates({
            key: "email_address_verify",
            value: 'true'
          }))
        } else {
          dispatch(
            setUpdateMDStates({
              key: "email_address_verify",
              value: "",
            })
          );
          // Clear recovery email if primary email is cleared
          if (!value) {
            dispatch(
              setUpdateMDStates({
                key: "recovery_email_address",
                value: "",
              })
            );
            dispatch(
              setUpdateMDStates({
                key: "recovery_email_address_verify",
                value: "",
              })
            );
          }
        }
        break;

      case "recovery_email_address":
        // Handle recovery email address verification
        if (verifiedRecoveryEmailAddress !== '' && verifiedRecoveryEmailAddress === value) {
          dispatch(setUpdateMDStates({
            key: "recovery_email_address_verify",
            value: 'true'
          }))
        } else {
          dispatch(
            setUpdateMDStates({
              key: "recovery_email_address_verify",
              value: "",
            })
          );
        }
        break;

      case "first_name":
        // If there's no ID (indicating a new entry), additional updates can be handled here
        if (!userId) {
          // Uncomment if resetting email and phone fields is required for a new user
          // dispatch(setUpdateMDStates({ key: "email_address", value: "" }));
          // dispatch(setUpdateMDStates({ key: "phone_number", value: "" }));
        }
        break;

      default:
        break;
    }
  };


  // Validation function
  const validatePhoneNumbers = (): boolean => {
    let isAnyNotVerified = false; // Flag to track if any phone number is not verified

    phoneNumbers.forEach((phone) => {
      if (phone.isVerified !== "true" && phone.value.length > 6) {
        // Set error for this phone number
        dispatch(setErrorById({ id: phone.id, error: "Please verify your secondary phone number" }));
        isAnyNotVerified = true; // Set flag to true
      } else {
        // Clear the error if the conditions are not met
        dispatch(setErrorById({ id: phone.id, error: "" }));
      }
    });

    return isAnyNotVerified; // Return whether any phone number is not verified
  };
  const handleSubmit = async () => {
    try {
      dispatch(setAddLoading(true));
      // Mandatory field validation
      const mandatoryField: any = {
        first_name,
        phone_number,
        date_of_birth,
        gender,
        nationality,
        profession,
        country,
      };

      if (country.toLowerCase() === "afghanistan") {
        mandatoryField.province = province;
        if (province) mandatoryField.district = district;
      } else {
        if (country !== '') {
          mandatoryField.province = province;
          mandatoryField.region = region;
          mandatoryField.postal_code = postal_code;
        }

      }
      const emptyFieldErrors = formEmptyValidation(mandatoryField);
      
      // Check wallet_access mandatory field
      if (wallet_access.length === 0) {
        emptyFieldErrors.wallet_access = "Please select at least one wallet";
      }
      
      if (Object.keys(emptyFieldErrors).length > 0) {
        dispatch(setAddMDError(emptyFieldErrors));
        const firstErrorKey = Object.keys(emptyFieldErrors)[0];
        if (firstErrorKey) {
          const errorElement = document.getElementById(firstErrorKey);
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            setTimeout(() => errorElement.focus(), 300); // Delay focus to ensure scrolling completes
          }
        }
        return;
      }
      
      // Verify email and phone number
      if ((email_address || email_address !== '') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_address)) {
        dispatch(setAddMDError({ email_address: "Invalid email address" }));
        return;
      }
      if ((email_address !== '' && !email_address_verify) || !phone_number_verify) {
        const errors: Record<string, string> = {};
        if (email_address !== '' && !email_address_verify)
          errors.email_address = "Please verify your email address";
        if (!phone_number_verify)
          errors.phone_number = "Please verify your phone number";
        dispatch(setAddMDError(errors));
        return;
      }

      // Add validation for recovery email
      if (type === 'Customers' && selectedOption === 'Corporate' && recovery_email_address && !email_address_verify) {
        dispatch(setAddMDError({
          email_address: "Please verify your email address before adding a recovery email"
        }));
        return;
      }

      //validation for phone numbers
      if (validatePhoneNumbers()) {
        return;
      }

      if (areas.region && areas.provinces.length === 0) {
        dispatch(showToast({
          type: "error",
          message: 'Please select atleast one province',
        }))
        return;
      }

      // Validate API access IPs
      if (is_api_user) {
        const validIps = whitelisted_ips.filter(ip => ip.trim() !== '');
        if (validIps.length === 0) {
          setApiAccessError('At least one IP address is required when API access is enabled');
          return;
        }
        const errors = validateAllIps(whitelisted_ips);
        if (errors.some(e => e !== '')) {
          setIpErrors(errors);
          return;
        }
      }

      const walletAccess =
        wallet_access.length === 0
          ? undefined
          : wallet_access.map((item) => {
            return transformString(item).toLocaleLowerCase();
          });

      if (!walletAccess) {
        dispatch(setAddMDError({ wallet_access: "Please select at least one wallet" }))
        return;
      }

      // Filter and map to create the new array
      const verifiedPhoneNumbers = phoneNumbers
        .filter((phone) => phone.isVerified === "true" && phone.value.length > 6) // Filter only verified phone numbers
        .map((phone) => ({
          country_code: `+${phone.countryCode}`, // Use "country_code" as the key
          phone_number: phone.value.replace(`${phone.countryCode}`, ''), // Use "value" as the key
        }));

      //filtering out the business areas
      const businessAreas = areas;
      // Prepare payload
      let payload = {
        'basic_details': {
          first_name:
            userId && editData.first_name === first_name
              ? undefined
              : first_name.trim(),
          last_name:
            last_name?.trim(),
          country_code: `+${country_code}`,
          phone_number: `${phone_number.trim().replace(country_code, '')}`,
          email_address:
            !email_address?.trim()
              ? undefined
              : userId && editData.email_address === email_address
                ? undefined
                : email_address.trim(),
          ...(type === 'Customers' && selectedOption === 'Corporate' && {
            recovery_email_address: userId && editData.recovery_email_address === recovery_email_address
              ? undefined
              : recovery_email_address?.trim() || undefined
          }),
          gender: userId && editData.gender === gender
            ? undefined
            : gender?.trim(),
          nationality: userId && editData.nationality === nationality ?
            undefined : nationality?.trim(),
          profession: userId && editData.profession === profession ?
            undefined : profession?.trim(),
          date_of_birth: userId && editData.date_of_birth === date_of_birth
            ? undefined
            : date_of_birth,

          country:
            userId && editData.country === country ? undefined : country?.trim(),
          city_town:
            userId && editData.city_town === city_town
              ? undefined
              : city_town?.trim() || undefined,
          house_no:
            userId && editData.house_no === house_no
              ? undefined
              : house_no?.trim() || undefined,
          market_block_no:
            userId && editData.market_block_no === market_block_no
              ? undefined
              : market_block_no?.trim() || undefined,
          floor_no:
            userId && editData.floor_no === floor_no
              ? undefined
              : floor_no?.trim() || undefined,
          street_name:
            userId && editData.street_name === street_name
              ? undefined
              : street_name?.trim() || undefined,
          province:
            userId && editData.province === province ? undefined : province?.trim(),
          region:
            userId && editData.region === region
              ? undefined
              : region?.trim() || undefined,
          district:
            userId && editData.district === district
              ? undefined
              : district?.trim() || undefined,
          postal_code:
            userId && editData.postal_code === postal_code
              ? undefined
              : postal_code?.trim() || undefined,
          wallet_access: walletAccess,
          ...(type !== "Customers" && { is_api_user: is_api_user }),
          ...(type !== "Customers" && { whitelisted_ips: is_api_user ? whitelisted_ips.filter(ip => ip.trim() !== '') : undefined }),
          secondary_phone_numbers: verifiedPhoneNumbers,
          ...(businessAreas.region !== '' && { business_assigned_area: businessAreas }),
          latitude: userId && editData?.latitude === coordinates?.latitude
            ? undefined
            : coordinates?.latitude || undefined,
          longitude: userId && editData?.longitude === coordinates?.longitude
            ? undefined
            : coordinates?.longitude || undefined,
          location_name: `${locationInfo?.address.city || ""}, ${locationInfo?.address.country || locationInfo?.address.state || ""}`.replace(
            /^,\s/,
            "",
          )
        }
      };
      //validation check for the change in nationality of the distributor, 
      // if nationality  is changed the user should be moved to nex tidentification page and fill the visa details if the  selected identification is passport
      // if (nationality !== "Afghanistan" && savedData['identification details'] && savedData?.['identification details']?.['identification_type'] === "Passport" && !savedData?.['identification details']?.document_details?.visa_number && savedData['basic details']?.nationality === "Afghanistan") {
      //   dispatch(showToast({
      //     type: "error",
      //     message: `VISA details are mandatory if the selected nationality is other than Afghanistan`,
      //   }));
      //   dispatch(setPayloadFornationality(payload));
      //   setCurrentStep(2);
      //   return;
      // }
      let res;
      if (type === 'Customers') {
        payload = {
          "customer_type": selectedOption,
          ...payload
        }
      }

      const headers = { 'x-source-page': 'onboarding-request' };
      res = user_id
        ? await PatchAPI(`${type?.toLowerCase()?.split(' ').join('-')}/${user_id}`, payload, true, tab ? headers : undefined)
        : await PostAPI(`${type?.toLowerCase()?.split(' ').join('-')}`, payload);
      // Submit payload

      if (!res.error) {
        if (user_id) {
          let savedDetails = savedData['basic details'] || {};
          const filteredDetails = Object.keys(payload.basic_details).reduce(
            (acc: Record<string, any>, key: string) => {
              if (payload.basic_details[key as keyof typeof payload.basic_details] !== undefined) {
                acc[key] = payload.basic_details[key as keyof typeof payload.basic_details];
              }
              return acc;
            }, {}
          );
          savedDetails = { ...savedDetails, ...filteredDetails }
          dispatch(setSavedData({ key: 'basic details', value: savedDetails }))
          dispatch(setPayloadFornationality({}));
          handleNext();
        } else {
          dispatch(setUserId(res.data.data.id));
          dispatch(setSavedData({ key: 'basic details', value: payload.basic_details }))
          handleNext();
        }
      } else if (res.data.message === "Request failed with status code 409") {
        dispatch(
          setAddMDError({
            [res.data.response.data.field]: res.data.response.data.message,
          })
        );
      } else {
        dispatch(
          showToast({
            type: "error",
            message: res?.data?.response?.data?.message || 'Something went wrong',
          })
        );
        if (res?.data?.response?.data?.message?.includes('VISA details are mandatory if the selected')) {
          dispatch(setPayloadFornationality(payload));
          setCurrentStep(2);
        }
      }
    } catch (error) {
      console.error("Error during admin creation:", error);
    } finally {
      dispatch(setAddLoading(false));
    }
  };


  const fecthDistributorDetails = async () => {
    setEditLoading(true);
    const endpoint = `${type?.toLowerCase()?.split(' ').join('-')}/${userId}`;
    const response = await getAPI(endpoint);

    if (!response.error) {
      // Store main data object
      setSelectedOption(response.data.data.customer_type);
      dispatch(updateMDDetails(response.data));
      dispatch(setProfileStatus(response.data.data.profile))
      console.log(response.data.data.has_children, 'response.data')
      dispatch(setHasChildren(response.data.data.has_children || false));
      // Check if email exists
      if (response?.data?.data?.basic_details?.email_address) {
        setEmailEdited(true);
      }
      if (response?.data?.data?.basic_details?.recovery_email_address !== '') {
        dispatch(setUpdateMDStates({
          key: "recovery_email_address_verify",
          value: 'true'
        }))
      }
      dispatch(setVerifiedPhoneNumber(response?.data?.data?.basic_details?.country_code + response?.data?.data?.basic_details?.phone_number));

      // Process geographic location data
      const locationData = {
        latitude: response?.data?.data?.basic_details?.latitude || undefined,
        longitude: response?.data?.data?.basic_details?.longitude || undefined,
      };

      if (locationData.latitude && locationData.longitude) {
        dispatch(setCoordinates(locationData));
        dispatch(setLocationInfo(response?.data?.data?.basic_details?.location_name));
        dispatch(setShowFields(true));
      }

      // Handle business area assignment
      if (response?.data?.data?.basic_details?.business_assigned_area?.region !== '' && type !== 'Customers') {
        dispatch(setRegion(response?.data?.data?.basic_details?.business_assigned_area.region));
      }
      if (response?.data?.data?.basic_details?.business_assigned_area?.provinces && response?.data?.data?.basic_details?.business_assigned_area?.provinces?.length !== 0 && type !== 'Customers') {
        dispatch(setProvinces(response?.data?.data?.basic_details?.business_assigned_area.provinces));
      }

      // Process secondary phone numbers
      if (response?.data?.data?.basic_details?.secondary_phone_numbers?.length > 0) {
        const formattedPhoneNumbers = response?.data?.data?.basic_details?.secondary_phone_numbers.map((phone: any, index: number) => ({
          id: (index + 1).toString(),
          value: phone.country_code.split('+')[1] + phone.phone_number,
          isVerified: "true",
          countryCode: phone.country_code.split('+')[1],
          loading: false,
          error: ""
        }));
        dispatch(setPhoneNumber(formattedPhoneNumbers));
        dispatch(setSecondaryPhoneNumbers(response?.data?.data?.basic_details?.secondary_phone_numbers))
        dispatch(setUpdateMDStates({
          key: "secondary_phone_numbers",
          value: response?.data?.data?.basic_details?.secondary_phone_numbers
        }))
        if (formattedPhoneNumbers.length > 0) {
          const phoneNumbersArray = formattedPhoneNumbers?.map((phone: any) => ({
            id: phone.id, // Already a string (convert to number when dispatching)
            value: phone.value, // Concatenated country code and phone number
          }));

          // Dispatching Redux action for each phone number
          phoneNumbersArray?.forEach((phone: any) => {
            dispatch(setVerifiedSecondaryPhoneNumbers({
              id: Number(phone.id) - 1,
              value: '+' + phone.value
            }));
          });
        }
      } else {
        dispatch(resetPhoneNumbers());
        dispatch(setSecondaryPhoneNumbers([]))

      }

      // Handle profile photo
      if (response?.data?.data?.photo) {
        setUploadedImage(config.cdnURL + 'public/' + response?.data?.data?.photo);
        setIsUploadedPhoto(true);
      } else {
        setIsUploadedPhoto(false);
      }

      // Organize data for storage
      const dataObj = response.data.data;
      const organizedData = {
        ...(dataObj?.basic_details && {
          "basic details": dataObj.basic_details,
        }),
        ...(dataObj?.identification_details?.identification_type && {
          "identification details": dataObj.identification_details,
        }),
        ...(dataObj?.bank_details &&
          Object.keys(dataObj.bank_details).length > 0 && {
          "bank details": dataObj.bank_details,
        }),
        ...(dataObj?.business_details &&
          Object.keys(dataObj.business_details).length > 0 && {
          "business details": dataObj.business_details,
        }),
        ...(dataObj?.photo && { photo: dataObj.photo }),
        ...(dataObj?.service_fee?.service_fee_type && {
          "service fee": dataObj.service_fee,
        }),
        ...(dataObj?.corporate_details &&
          type === "Customers" &&
          dataObj?.customer_type === "Corporate" && {
          "corporate details": dataObj.corporate_details,
        }),
      };
      dispatch(setEditSavedData(organizedData));
      if (type === 'Customers') {
        dispatch(
          setCorporateDetails({
            company_id: dataObj?.corporate_details.company_id,
            employee_id_number: dataObj?.corporate_details.employee_id_card_number,
            employee_id_card_front_page: dataObj?.corporate_details.employee_id_card_front_page,
          })
        );
      }
      dispatch(setUserId(userId || id || ''));
    } else {
      console.error('error');
    }

    setEditLoading(false);
  };

  useEffect(() => {
    if (userId) {
      fecthDistributorDetails();
    } else {
      dispatch(resetAddMD());
      dispatch(resetPhoneNumbers());
      dispatch(resetBusinessAreas());
      dispatch(resetLocation());
      dispatch(setCompleteServiceFee({
        service_fee_type: "",
        service_fee_parent: "",
        service_fee_parent_name: ""
      }))
    }
  }, []);

  const checkForDuplicatePhoneNumbers = (
    keyToCheck: string
  ): boolean => {
    const primaryNumber = {
      countryCode: country_code,
      value: phone_number,
      isVerified: phone_number_verify,
    };
    const allPhoneNumbers = [...phoneNumbers, primaryNumber];



    // Loop through phoneNumbers and check if any value matches sanitizedKey
    for (const phone of allPhoneNumbers) {
      if (phone.value === keyToCheck.replace('+', '') && phone.isVerified) {
        dispatch(showToast({
          type: "error",
          message: `Phone numbers must be unique.`,
        }));
        return true; // Stop execution immediately
      }
    }

    return false;
  };

  const handleVerify = async (id: string, resend: boolean, type?: string, idNumber?: string) => {
    let phoneNumber = `+${phone_number}`;
    let countryCode = `+${country_code}`;
    if (type === 'secondary_phone_number') {
      dispatch(setErrorById({ id: idNumber || '', error: "" }));
      phoneNumbers.forEach((item) => {
        if (item.id === idNumber) {
          phoneNumber = `+${item.value}`
          id = 'phone_number'
          countryCode = `+${item.countryCode}`;
        }
      })
    }
    const errors: Record<string, string> = {};
    if (id === "phone_number") errors.phone_number = "";
    if (id === "email_address") errors.email_address = "";
    if (id === "recovery_email_address") errors.recovery_email_address = "";
    dispatch(setAddMDError(errors));
    if (id === "phone_number" && checkForDuplicatePhoneNumbers(phoneNumber)) {
      return;
    }
    try {
      if (type === 'secondary_phone_number') {
        dispatch(setLoadingStateById({ id: idNumber || '', loading: true }));
      } else {
        dispatch(setAddMDLoader({ key: id, value: true }));
      }
      dispatch(setDisableState(true));
      const payload =
        id === "phone_number"
          ? {
            phone_number: `${phoneNumber}`,
            name: first_name,
            user_type: userVerification[userType]
          }
          : id === "email_address" ? {
            email_address: `${email_address}`,
            name: first_name,
            user_type: userVerification[userType]
          } : {
            email_address: `${recovery_email_address}`,
            name: first_name,
            user_type: userVerification[userType]
          }
      const response = await PostAPI(otpSend, payload);
      if (!response.error) {
        // Reset OTP state when a new OTP is successfully sent
        dispatch(resetOtp());
        if (id === 'phone_number') {
          setCurrentPhone(phoneNumber);
        }
        setIsOpenOtpModel(true);
        if (type === 'secondary_phone_number') {
          dispatch(
            showToast({
              type: "info",
              message: resend
                ? "OTP resent"
                : `OTP has been sent to ${`${countryCode} ${phoneNumber.replace(`${countryCode}`, '')}`}`,
            })
          );
        } else {
          dispatch(
            showToast({
              type: "info",
              message: resend
                ? "OTP resent"
                : `OTP has been sent to ${id === "phone_number" ? `${`${countryCode} ${phoneNumber.replace(`${countryCode}`, '')}`}` : id === "recovery_email_address" ? recovery_email_address : email_address
                }`,
            })
          );
        }
        dispatch(setIsOpenModel(true));
        dispatch(
          setInstructionText({
            text: `We have sent a code to ${id === "phone_number" ? `+${phone_number}` : id === "recovery_email_address" ? recovery_email_address : email_address
              }`,
            id,
          })
        );
      } else {
        dispatch(
          showToast({
            type: "error",
            message: response?.data?.response?.data?.message,
          })
        );
      }
    } catch (error) {
      dispatch(setAddMDFelidError(id));
      console.error("Error sending OTP:", error);
      dispatch(
        showToast({
          type: "error",
          message: "Failed to send OTP. Please try again.",
        })
      );
    } finally {
      if (type === 'secondary_phone_number') {
        dispatch(setLoadingStateById({ id: idNumber || "", loading: false }));
      } else {
        dispatch(setAddMDLoader({ key: id, value: false }));
      }
      dispatch(setDisableState(false));
    }
  };

  //type object for the user verification
  type UserVerification = {
    [key: string]: string;
  };
  const userVerification: UserVerification = {
    'Master Distributors': 'MDST',
    'Distributors': 'DST',
  };
  const handleSubmitOTP = async (key?: string) => {
    dispatch(setLoading(true));
    const payload =
      (selectedOTPid === "phone_number" || selectedOTPid === 'secondary_phone_number')
        ? {
          phone_number: `${currentPhone}`,
          otp: otp.join(""),
          user_type: userVerification[type]
        }
        : selectedOTPid === 'email_address' ? {
          email_address: email_address,
          otp: otp.join(""),
          user_type: userVerification[type]
        } : {
          email_address: recovery_email_address,
          otp: otp.join(""),
          user_type: userVerification[type]
        }

    try {
      const res = await PostAPI(otpVerify, payload);
      if (!res.error) {
        if (key) {
          dispatch(setIsVerifiedById({ id: key, isVerified: 'true' }));
          dispatch(setVerifiedSecondaryPhoneNumbers({ id: Number(key) - 1, value: payload.phone_number }));
        } else {
          handleInputValues(
            selectedOTPid === "phone_number"
              ? "phone_number_verify"
              : selectedOTPid === 'email_address' ? "email_address_verify" : selectedOTPid === 'recovery_email_address' ? "recovery_email_address_verify" : '',
            "true" // Assuming value should be "true"
          );
          if (selectedOTPid !== 'phone_number' && selectedOTPid !== 'secondary_phone_number') {
            if (selectedOTPid === 'email_address') {
              dispatch(setIsVerifiedById({ id: selectedOTPid, isVerified: 'true' }));
              dispatch(setVerifiedEmailAddress(payload.email_address));
            } else {
              dispatch(setIsVerifiedById({ id: selectedOTPid, isVerified: 'true' }));
              dispatch(setVerifiedRecoveryEmailAddress(payload?.recovery_email_address));
            }
          }
        }
        dispatch(setVerifiedPhoneNumber(payload.phone_number));
        setIsOpenOtpModel(false);
        dispatch(setOtp({ otp: [] }));
        dispatch(setIsVerifiedFirst(false));
      } else {
        dispatch(
          setErrorMessage(res.data.response.data.message || "Invalid OTP.")
        );
      }
    } catch (error: any) {
      console.error("Error verifying OTP:", error);
      dispatch(setErrorMessage("Invalid OTP. Please try again."));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handelCheckBox = (id: string) => {
    dispatch(setCheckBox(id));
    dispatch(setUpdateMDStates({
      key: "wallet_access",
      value: id
    }))
    dispatch(setAddMDError({ wallet_access: "" }));
  };

  const validateIp = (ip: string): string => {
    if (!ip.trim()) return '';
    const cleanIp = ip.trim();
    const cidrRegex = /^(\d{1,3}\.){3}\d{1,3}\/(\d{1,2})$/;
    if (!cidrRegex.test(cleanIp)) {
      return 'Must be a valid IPv4 CIDR (e.g. 10.0.0.0/24)';
    }
    const [ipPart, prefixPart] = cleanIp.split('/');
    const octets = ipPart.split('.');
    for (const octet of octets) {
      if (parseInt(octet, 10) > 255) {
        return 'Each octet must be between 0 and 255';
      }
    }
    const prefix = parseInt(prefixPart, 10);
    if (prefix < 1 || prefix > 32) {
      return 'Prefix must be between /1 and /32';
    }
    return '';
  };

  const handleApiToggle = () => {
    dispatch(setIsApiUser(!is_api_user));
    setApiAccessError('');
    setIpErrors([]);
  };

  const validateAllIps = (ips: string[]) =>
    ips.map((ip, i) => {
      const formatError = validateIp(ip);
      if (formatError) return formatError;
      const isDuplicate = ip.trim() !== '' && ips.some((other, j) => j !== i && other.trim() === ip.trim());
      return isDuplicate ? 'This IP address has already been added' : '';
    });

  const handleIpChange = (index: number, value: string) => {
    const updated = [...whitelisted_ips];
    updated[index] = value;
    dispatch(setWhitelistedIps(updated));
    setIpErrors(validateAllIps(updated));
    if (apiAccessError) setApiAccessError('');
  };

  const handleAddIp = () => {
    if (whitelisted_ips.length < 5) {
      dispatch(setWhitelistedIps([...whitelisted_ips, '']));
      setIpErrors([...ipErrors, '']);
    }
  };

  const handleRemoveIp = (index: number) => {
    const updated = whitelisted_ips.filter((_, i) => i !== index);
    const final = updated.length > 0 ? updated : [''];
    dispatch(setWhitelistedIps(final));
    setIpErrors(validateAllIps(final));
  };

  const handleNext = () => {
    if (currentStep === 3 && type === "Customers") {
      setCurrentStep(5)
    } else {
      setCurrentStep((prev) => Math.min(prev + 1, 6));
    }
  };
  const currentSavedStep = () => {
    return Object.keys(savedData).length;
  }
  const handleResetClick = () => {
    switch (currentStep) {
      case 1:
        break;
      case 2:
        if (childRef.current) {
          childRef.current.handleSubmit(); // Call the child's function
        }
        break;
      case 3:
        if (bankDetailsRef.current) {
          bankDetailsRef.current.handleSubmit(); // Call the child's function
        }
        break;
      case 4:
        if (businessDetailsRef.current) {
          businessDetailsRef.current.handleSubmit(); // Call the child's function
        }
        break;
      case 5:
        if (photoUploadRef.current) {
          photoUploadRef.current.handleSubmit(); // Call the child's function
        }
        break;
      case 6:
        if (serviceFeeRef.current) {
          serviceFeeRef.current.handleSubmit();
        } else if (corporateCustomerRef.current && type === 'Customers') {
          corporateCustomerRef.current.handleSubmit();
        }
        break;
      case 7:

        break;
      default:
        break;
    }

  };

  //handle skip button
  const handleSkip = () => {
    if (currentStep === 2) {
      // Skip Identification Details
      if (!userId) {
        dispatch(setSavedData({ key: 'identification details', value: null }));
      } else {
        dispatch(setSavedData({ key: 'identification details', value: null }));
      }
      setCurrentStep(currentStep + 1);
      dispatch(resetIdentificationDetails({ id: 'passport' }));
      dispatch(resetIdentificationDetails({ id: 'national_id' }));
    }

    if (currentStep === 3) {
      if (!userId) {
        dispatch(setSavedData({ key: 'bank details', value: [] }));
      } else {
        if (Array.isArray(BankDetails) && BankDetails.length > 0 && !BankDetails[0]['bank_name']) {
          dispatch(setSavedData({ key: 'bank details', value: BankDetails }));
        }
      }
      let nextStep = type !== "Customers" ? currentStep + 1 : currentStep + 2
      setCurrentStep(nextStep);
      dispatch(resetBankDetails());
    }

    if (currentStep === 5) {
      if (!userId) {
        dispatch(setSavedData({ key: 'photo', value: '' }));
      } else {
        dispatch(setSavedData({ key: 'photo', value: uploadedImage || '' }));
      }
      if (type !== "Customers") {
        setCurrentStep(currentStep + 1);
      } else {
        // const getUrlPath = (type: any) => type?.toLowerCase().split(' ').join('-');
        // navigate(`/user-management/customer-management`);
        if (selectedOption === 'Corporate' && type === 'Customers') {
          setCurrentStep(6)
        } else if (selectedOption === 'Individual' && type === 'Customers') {
          // For customers with pending profile, always show terms and conditions
          if (userId && profile === 'Pending') {
            setTermsAndConditions(true);
          } else {
            setTermsAndConditions(true);
          }
        }
      }
      dispatch(resetPhotoUploads());
    }
  };
  //creating payload for disabled button
  const getPayload = () => {
    const walletAccess =
      wallet_access.length === 0
        ? undefined
        : wallet_access.map((item) => {
          return transformString(item).toLocaleLowerCase();
        });

    // Filter and map to create the new array
    const verifiedPhoneNumbers = phoneNumbers
      .filter((phone) => phone.isVerified === "true" && phone.value.length > 6) // Filter only verified phone numbers
      .map((phone) => ({
        country_code: `${phone.countryCode}`, // Use "country_code" as the key
        phone_number: phone.value.replace(phone.countryCode, ''), // Use "value" as the key
      }));

    //filtering out the business areas
    const businessAreas = areas;
    const payload = {
      first_name: first_name.trim(),
      last_name: last_name?.trim(),
      country_code: `+${country_code}`,
      phone_number: `${phone_number.trim().replace(country_code, '')}`,
      email_address: email_address?.trim(),
      gender: gender?.trim(),
      nationality: nationality?.trim(),
      profession: profession?.trim(),
      date_of_birth: date_of_birth ? convertDate(date_of_birth) : '',
      country: country?.trim(),
      city_town: city_town?.trim(),
      house_no: house_no?.trim() || '',
      market_block_no: market_block_no?.trim() || '',
      floor_no: floor_no?.trim() || '',
      street_name: street_name?.trim() || '',
      province: province?.trim() || '',
      region: region?.trim() || '',
      district: district?.trim() || '',
      postal_code: postal_code?.trim() || '',
      wallet_access: walletAccess,
      ...(type !== "Customers" && { is_api_user: is_api_user }),
      ...(type !== "Customers" && { whitelisted_ips: is_api_user ? whitelisted_ips.filter(ip => ip.trim() !== '') : undefined }),
      secondary_phone_numbers: verifiedPhoneNumbers,
      business_assigned_area: businessAreas,
      latitude: coordinates?.latitude || null,
      longitude: coordinates?.longitude || null,
      location_name: `${locationInfo?.address?.city || ""}, ${locationInfo?.address?.country || locationInfo?.address?.state || ""}`.replace(
        /^,\s/,
        "",
      )
    }
    return payload;
  }

  //handle button disabler function
  const disableButton = () => {
    if (!userId) return false; // Always enable button for new entries
    switch (currentStep) {
      case 1: {
        // Basic Details comparison - exclude wallet_access from addAdminDetails comparison
        const { wallet_access: _, ...adminDetailsWithoutWallet } = addAdminDetails;
        const { wallet_access: __, ...editDataWithoutWallet } = editData;
        const isDetailsEqual = deepEqual(adminDetailsWithoutWallet, editDataWithoutWallet);
        const savedBusinessArea = savedData['basic details']?.business_assigned_area;
        const currentBusinessArea = businessAreas.areas;
        const isBusinessAreasEqual = type !== 'Customers' 
          ? ((!savedBusinessArea || Object.keys(savedBusinessArea).length === 0) && 
             (!currentBusinessArea.region && currentBusinessArea.provinces.length === 0))
            ? true 
            : deepEqual(currentBusinessArea, savedBusinessArea)
          : true;

        const isPhoneNumbersEqual = deepEqual(secondary_phone_numbers, savedData['basic details']?.secondary_phone_numbers, true);
        const isWalletAccessEqual = deepEqual(wallet_access, wallet_access_edit);
        const isApiUserEqual = is_api_user === is_api_user_edit;
        const isWhitelistedIpsEqual = deepEqual(
          whitelisted_ips.filter(ip => ip.trim() !== ''),
          whitelisted_ips_edit
        );

        return isDetailsEqual && isBusinessAreasEqual && isPhoneNumbersEqual && isWalletAccessEqual && isApiUserEqual && isWhitelistedIpsEqual;
      }
      case 2: {
        // Identification Details comparison
        if (!savedData['identification details']) return false;
        if (identificationDetails.identification_type === 'Passport'){
          return deepEqual(identificationDetails.passport, savedData['identification details']?.document_details);
        } else if (identificationDetails.identification_type === 'National ID'){
          return deepEqual(identificationDetails.national_id, savedData['identification details']?.document_details);
        }
        return false;
      }
      case 3: {
        // Bank Details comparison
        if (!savedData['bank details']) return false;
        return deepEqual(bankDetails, savedData['bank details']);
      }
      case 4: {
        // Business Details comparison
        if (!savedData['business details']) return false;
        const currentData = addAdminDetails;
        return deepEqual(currentData, savedData['business details']);
      }
      case 5: {
        // Photo comparison
        if (!savedData['photo']) return false;
        return photoUpload === savedData['photo'];
      }
      case 6: {
        // Service Fee comparison
        if(type !== 'Customers'){
          if (!savedData['service fee']) return false;
          const currentData = addAdminDetails;
          return deepEqual(currentData, savedData['service fee']);
        }else{
          return deepEqual(savedData['corporate details'], corporateDetails)
        }
      }
      default:
        return false;
    }
  }
  const handleCustomerTypeChange = (value: string) => {
    if (customerType) {
      setSelectedOption(customerType)
    } else {
      setSelectedOption(value);
    }
    // Reset all addMDSlice states
    dispatch(resetAddMD());
    dispatch(resetPhoneNumbers());
    dispatch(resetBusinessAreas());
    dispatch(resetLocation());
    dispatch(setCompleteServiceFee({
      service_fee_type: "",
      service_fee_parent: "",
      service_fee_parent_name: "",
      upfront_service_fee_percentage: 0
    }));
    dispatch(setSavedData({
      key: "",
      value: ""
    }));
    dispatch(setEditSavedData({}));
    dispatch(setUserId(""));
    dispatch(setVerifiedPhoneNumber(""));
    dispatch(setVerifiedEmailAddress(""));
    dispatch(setProfileStatus(""));
    dispatch(setDisableState(false));
    dispatch(setAddLoading(false));
    dispatch(setAddMDLoader({
      key: "",
      value: false
    }));
    dispatch(setAddMDError({}));
    dispatch(setUpdateMDStates({
      key: "",
      value: ""
    }));
    dispatch(setPayloadFornationality({}));
    dispatch(setIsVerifiedFirst(false));
    dispatch(setEditSavedData({}));
    dispatch(setSavedData({
      key: "",
      value: ""
    }));
    // Reset corporate details state
    dispatch(setCorporateDetails({
      company_id: "",
      employee_id_number: "",
      employee_id_card_front_page: ""
    }));
    // Reset current step to 1
    setCurrentStep(1);
  };
  // Scroll to top whenever currentStep changes or on component mount
  useEffect(() => {
    if (divRef.current) {
      (divRef.current as HTMLDivElement).scrollTop = 0;
    }
  }, [currentStep]);

  if (addCvmClicked) {
    return (
      <AddCVM
        id={userId || id || ""}
        type={type}
        setAddCvmClicked={setAddCvmClicked}
        setTermsAndConditions={setTermsAndConditions}
        termsAndConditions={termsAndConditions}

      // handleNext={handleNext}
      // ref={addCvmRef}
      />
    )
  }
  return (
    <div className="">
      <Breadcrumbs
        navPath={
          tab
            ? [
              "Onboarding / Modification Request",
              "List of Onboarding Requests",
              "View Details",
              `Edit ${type.slice(0, -1)}`,
            ]
            : [
              "User Management",
              `${type.slice(0, -1)} Management`,
              `List of ${type}`,
              ...(userPreviousUrl ? [`View Details`] : []),
              ...(userId
                ? [`Edit ${type.slice(0, -1)}`]
                : [`Add ${type.slice(0, -1)}`]),
            ]
        }
        heading={
          tab
            ? `Edit ${tab}`
            : `${userId ? "Edit" : "Add"} ${type.slice(0, -1)}`
        }
        links={
          tab
            ? [
              pathname
                ? pathname
                : `/${tab.split(" ")[0].toLowerCase()}-request/${tab
                  .split(" ")[0]
                  .toLowerCase()}`,
              pathname
                ? pathname
                : `/${tab.split(" ")[0].toLowerCase()}-request/${tab
                  .split(" ")[0]
                  .toLowerCase()}`,
              `/${tab.split(" ")[0].toLowerCase()}-request/${tab
                .split(" ")[0]
                .toLowerCase()}/view-${tab
                  .split(" ")[0]
                  .toLowerCase()}-request/${type
                    .toLowerCase()
                    .slice(0, -1)
                    .replace(/ /g, "-")}/${id}`,
            ]
            : userPreviousUrl
              ? [
                `/user-management/${type
                  .toLowerCase()
                  .replace(/ /g, "-")
                  .slice(0, -1)}-management`,
                `/user-management/${type
                  .toLowerCase()
                  .replace(/ /g, "-")
                  .slice(0, -1)}-management`,
                `/user-management/${type
                  .toLowerCase()
                  .replace(/ /g, "-")
                  .slice(0, -1)}-management`,
                userPreviousUrl,
              ]
              : pathname
                ? [pathname, pathname, pathname]
                : [
                  `/user-management/${type
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .slice(0, -1)}-management`,
                  `/user-management/${type
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .slice(0, -1)}-management`,
                  `/user-management/${type
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .slice(0, -1)}-management`,
                ]
        }
      />{" "}
      <AddModel noScroll={true}>
        <div className="sticky top-0 z-10 bg-white">
          {type === "Customers" && (
            <div className="mb-4">
              <h1 className="text-xl underline font-semibold mb-2">
                Customer Type
              </h1>
              <CustomRadioButton
                options={[
                  { id: "Individual", label: "Individual Customer" },
                  { id: "Corporate", label: "Corporate Customer" },
                ]}
                selected={selectedOption}
                onChange={handleCustomerTypeChange}
                padding="py-3 pr-3"
              />
            </div>
          )}
          <ProgressStepper
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            currentSavedStep={currentSavedStep()}
            selectedOption={selectedOption}
            type={type}
            id={userId}
          />
        </div>
        <div
          ref={divRef}
          className={`${type !== "Customers" ? "h-addmdheight" : "h-addmdheight2"} overflow-y-auto pr-2 ${getFirefoxCssFix(
            "scroll"
          )}`}
        >
          {currentStep === 1 && (
            <BasicDetails
              editLoading={editLoading}
              addMDLoader={addMDLoader}
              disableAll={disableAll}
              handleInputValues={handleInputValues}
              addAdminDetails={addAdminDetails}
              handleVerify={handleVerify}
              felidError={felidError}
              errors={errors}
              handleSubmitOTP={handleSubmitOTP}
              isOpenOtpModel={isOpenOtpModel}
              setIsOpenOtpModel={setIsOpenOtpModel}
              id={userId}
              wallet_access={wallet_access}
              handelCheckBox={handelCheckBox}
              inputCordinates={inputCordinates}
              setInputCordinates={setInputCordinates}
              type={type}
              emailEdited={emailEdited}
              selectedOption={selectedOption}
              is_api_user={is_api_user}
              handleApiToggle={handleApiToggle}
              whitelisted_ips={whitelisted_ips}
              handleIpChange={handleIpChange}
              handleAddIp={handleAddIp}
              handleRemoveIp={handleRemoveIp}
              apiAccessError={apiAccessError}
              ipErrors={ipErrors}
            />
          )}
          {currentStep === 2 && (
            <IdentificationDetails
              ref={childRef}
              adminDetails={addAdminDetails}
              handleNext={handleNext}
              id={userId || id || ""}
              type={type}
            />
          )}
          {currentStep === 3 && (
            <BankDetails
              handleNext={handleNext}
              ref={bankDetailsRef}
              type={type}
              id={userId || id || ""}
              firstIndex={firstIndex}
            />
          )}
          {currentStep === 4 && type !== "Customers" && (
            <BusinessDetails
              handleNext={handleNext}
              ref={businessDetailsRef}
              type={type}
              id={userId || id || ""}
            />
          )}
          {(currentStep === 5 ||
            (currentStep === 4 && type === "Customers")) && (
              <PhotoUploadWithValidation
                id={Number(userId || id)}
                isFemale={gender === "Female" ? true : false}
                ref={photoUploadRef}
                type={type}
                handleNext={handleNext}
                setUploadedImage={setUploadedImage}
                uploadedImage={uploadedImage}
                selectedOption={selectedOption}
                isUploadedPhoto={isUploadedPhoto}
                setTermsAndConditions={setTermsAndConditions}
                termsAndConditions={termsAndConditions}
              />
            )}
          {(currentStep === 6 || step === 6) && type !== "Customers" && (
            <ServiceFee
              ref={serviceFeeRef}
              id={userId || id || ""}
              type={type}
              handleNext={handleNext}
              setAddCvmClicked={setAddCvmClicked}
              setEditLoading={setDisableServiceFee}
              onHasChanges={setHasServiceFeeChanges}
              onEditModalChange={setIsServiceFeeEditModalOpen}
            />
          )}
          {((currentStep === 6) && type === "Customers" && selectedOption === 'Corporate') && (
            <CorporateDetails
              ref={corporateCustomerRef}
              id={userId || id || ""}
              type={type}
              handleNext={handleNext}
            />
          )}
        </div>
      </AddModel>
      <AddBottomButton
        buttonName={`Save & Next`}
        buttonClass="w-[140px]"
        onClick={currentStep === 1 ? handleSubmit : handleResetClick}
        disabled={
          currentStep === 2 
            ? (() => {
                // Check if we're in edit mode using the edit prop
                const isEditMode = !!edit;
                
                // Simple direct check from Redux state - always uses latest values
                if (!identificationDetails.identification_type) {
                  return false; // No type selected = enabled (can skip)
                }
                
                // In edit mode: disable if nothing changed (compare with saved data)
                if (isEditMode) {
                  if (!savedData['identification details']) {
                    // No saved data means it was never set - check if current has values
                    if (identificationDetails.identification_type === 'Passport') {
                      const p = identificationDetails.passport;
                      return !(p?.passport_number || p?.passport_valid_from || p?.passport_valid_to || p?.passport_front_page);
                    }
                    if (identificationDetails.identification_type === 'National ID') {
                      const n = identificationDetails.national_id;
                      return !(n?.national_id_number || n?.national_id_valid_from || n?.national_id_valid_to || n?.mothers_name || n?.national_id_front_page || n?.national_id_back_page);
                    }
                    return false;
                  }
                  
                  if (identificationDetails.identification_type === 'Passport') {
                    return deepEqual(identificationDetails.passport, savedData['identification details']?.document_details);
                  } else if (identificationDetails.identification_type === 'National ID') {
                    return deepEqual(identificationDetails.national_id, savedData['identification details']?.document_details);
                  }
                  return false;
                }
                
                // In add mode: check if any fields are filled
                if (identificationDetails.identification_type === 'Passport') {
                  const p = identificationDetails.passport;
                  return !(p?.passport_number || p?.passport_valid_from || p?.passport_valid_to || p?.passport_front_page);
                }
                if (identificationDetails.identification_type === 'National ID') {
                  const n = identificationDetails.national_id;
                  return !(n?.national_id_number || n?.national_id_valid_from || n?.national_id_valid_to || n?.mothers_name || n?.national_id_front_page || n?.national_id_back_page);
                }
                return false;
              })()
            : currentStep === 5 || (currentStep === 4 && type === "Customers")
              ? (() => {
                  // Check if we're in edit mode using the edit prop
                  const isEditMode = !!edit;
                  
                  // In edit mode: disable if nothing changed (compare with saved data)
                  if (isEditMode) {
                    const savedPhoto = savedData['photo'] || '';
                    
                    // If photo was removed (empty now), enable button (removal is a change)
                    if (!uploadedImage) {
                      return false; // Photo removed - enable button
                    }
                    
                    // Normalize current photo to just the path
                    let currentPhotoPath = '';
                    if (uploadedImage) {
                      // If it's a data URL (new upload), we consider it changed
                      if (uploadedImage.startsWith('data:')) {
                        return false; // Changed - enable button
                      }
                      // Extract path from full URL or use as-is if already a path
                      const uploadsMatch = uploadedImage.match(/(?:uploads\/.*?)$/);
                      currentPhotoPath = uploadsMatch ? uploadsMatch[0] : uploadedImage;
                    }
                    
                    // Disable if they match (no change), enable if different
                    return currentPhotoPath === savedPhoto;
                  }
                  
                  // In add mode: disabled if no photo uploaded
                  return !uploadedImage;
                })()
            : currentStep === 6 && type !== "Customers" 
              ? (profile === 'Pending' && userId ? false : !hasServiceFeeChanges) 
              : userId 
                ? editLoading || disableButton() 
                : false
        }
        buttonWidth="w-[140px]"
        loading={(currentStep === 6 || step === 6) && type !== "Customers" ? add_loading && !isServiceFeeEditModalOpen : add_loading}
        testID={"add_admin_page"}
        tertiaryButtonName={
          currentStep === 2 || currentStep === 3 || currentStep === 5
            ? "Skip"
            : ""
        }
        tertiaryButtonFunction={
          currentStep === 2 || currentStep === 3 || currentStep === 5 || (currentStep === 4 && type === "Customers")
            ? handleSkip
            : undefined
        }
        tertiaryButtonClass={"text-heading4-semi"}
      />
    </div>
  );
}
